module.exports = __webpack_public_path__ + "static/media/applogomcg.789cd4b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/applogomcg.svg
// module id = 644
// module chunks = 11